import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { DURATION_MS } from 'app/constants/CronTimes';
import { getAuthenticatedOffers } from './api';
import { AuthenticatedOffer, PricingCatalogErrorCode } from './types';
import { PRICING_CATALOG_OFFERS_QUERY_KEY } from './queryKeys';

export { PRICING_CATALOG_OFFERS_QUERY_KEY };

type UsePricingCatalogOffersParams = {
  enabled: boolean;
};

type AuthUserState = {
  auth?: { user?: { id?: number } | null };
};

const getErrorCode = (error: unknown): PricingCatalogErrorCode | undefined =>
  (error as { response?: { data?: { code?: PricingCatalogErrorCode } } })?.response?.data?.code;

export function usePricingCatalogOffers({ enabled }: UsePricingCatalogOffersParams) {
  const userId = useSelector((state: AuthUserState) => state.auth?.user?.id);
  const { data, isLoading, isError, error, refetch } = useQuery<AuthenticatedOffer[]>({
    queryKey: [...PRICING_CATALOG_OFFERS_QUERY_KEY, userId],
    queryFn: getAuthenticatedOffers,
    enabled: enabled && userId != null,
    retry: false,
    staleTime: DURATION_MS.FIVE_MINUTES,
  });

  return {
    offers: data,
    isLoading,
    isError,
    errorCode: isError ? getErrorCode(error) : undefined,
    refetch,
  };
}
